<template>
  <div>
    <v-dialog v-model="categoryDialog" persistent max-width="400">
      <v-card>
        <v-card-title v-if="event == 'create'"
          >{{ $t('product.create_product_category') }}</v-card-title
        >
        <v-card-title v-if="event == 'edit'">{{ $t('product.edit_product_category') }}</v-card-title>
        <v-card-text class="py-5">
          <span>ERP ID</span>
          <v-text-field
            label="ERP ID"
            solo
            flat
            background-color="grey lighten-4"
            v-model="form.erpId"
          ></v-text-field>
          <span>{{ $t('product.product_category_th_name') }}</span>
          <v-text-field
            :label="$t('product.product_category_th_name')"
            solo
            flat
            background-color="grey lighten-4"
            v-model="form.name"
          ></v-text-field>
          <span>{{ $t('product.product_category_en_name') }}</span>
          <v-text-field
            :label="$t('product.product_category_en_name')"
            solo
            flat
            background-color="grey lighten-4"
            v-model="form.name_en"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn color="error" elevation="0" @click="categoryDialog = false">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn
            color="success"
            elevation="0"
            @click="event == 'create' ? saveCategory() : updateCategory()"
            :loading="isLoading"
            :disabled="form.name == ''"
          >
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "FormProductCategory",
  computed: {
    categoryDialog: {
      get() {
        this.form = {
          name: "",
          erpId: "",
          name_en: "",
        };
        if (this.value && this.event == "edit") {
          const newObj = Object.assign({}, this.obj);
          this.form = newObj;
          this.form.id = newObj.objectId;
        }
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {},
  data() {
    return {
      form: {
        name: "",
        erpId: "",
        name_en: "",
      },
      isLoading: false,
    };
  },
  props: {
    value: Boolean,
    event: String,
    obj: Object,
  },
  methods: {
    async saveCategory() {
      try {
        this.isLoading = true;
        await this.$store.dispatch(
          "productCategory/createProductCategory",
          this.form
        );
        this.categoryDialog = false;
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
      }
    },
    async updateCategory() {
      try {
        this.isLoading = true;
        await this.$store.dispatch(
          "productCategory/updateProductCategory",
          this.form
        );
        this.categoryDialog = false;
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
